<template>
  <div v-if="getUserRole === 'admin'">
    <!-- <div> -->
    <DeletionDialog 
        context="AccountCredentials" 
        :additionalDialogText="additionalDeletionDialogText" 
    />
    <CredentialsEditingDialog />
    <BaseListPage 
        :alvqa="alvqa" 
        :context="context" 
        headline="lang_ACCOUNT_CREDENTIALS" 
        :showFiltersRow='false'
        :showSearchIcon='false'
    >
      <template v-slot:dataTable>
        <BaseDataTableList 
            :headers="headers" 
            :showExpand="false" 
            :context="context" 
            :alvqa="alvqa"
        >
          <template v-slot:topSlot>
            <v-row>
              <v-spacer></v-spacer>
              <v-col cols="2">
                <BaseButton 
                    @click="addNewRow" 
                    label="lang_GENERAL_BUTTON_ADD_ROW" 
                    :alvqa="alvqa + '-button-add-row'"
                    block 
                />
              </v-col>
            </v-row>
          </template>
          <template v-slot:body="{ item }">
            <td 
              class="text-left" 
              :alvqa="alvqa + '-list-row-' + item.item.id + '-text-type'"
            >
              {{ $t(getType(item.item.credentialsType)) }}
            </td>
            <td 
              class="text-left" 
              :alvqa="alvqa + '-list-row-' + item.item.id + '-text-credentials'"
            >
              <span v-if="item.item.apikey !== null">
                {{ (item.item.apikey) ? maskApiKey(item.item.apikey) : ''}} 
              </span>
              <span v-else>
                 {{ (item.item.username) ? item.item.username : '' }}
              </span>
            </td>
            <td class="text-left">
              <span v-if="item.item.protocol !== null && item.item.protocol !== undefined && item.item.protocol.includes('REST')">{{item.item.protocol}}-API</span>
              <span v-else-if="item.item.role">{{ $t(getRole(item.item.role)) }}</span>
              <span v-else>{{ item.item.protocol }}</span> 
            </td>
            <td class="text-left">
            </td>
            <!-- Check if it is malchimp and then place sync option icon -->
            <td v-if="item.item.credentialsType.includes('mailchimp')" 
                class="text-center"
                :alvqa="alvqa + '-list-row-' + item.item.id + '-icon-sync'"
            >
              <BaseIcon 
                  v-if="showMailchimpSyncIcon"
                  @click="synchronizeContacts(item.item)"
                  tooltipText="lang_ACCOUNT_CREDENTIALS_CAPTION_TOOLTIP_SYNC" 
                  icon="sync" 
              />
              <span v-if="showMailchimpSyncProgressBar" class="pl-2">
                  <v-progress-circular 
                      size="16"
                      width="2"
                      color="dialogProgressbar"
                      indeterminate
                      :alvqa="alvqa + '-progress-bar-csv-report-bulk-edit-copy-shares'" 
                  ></v-progress-circular>
              </span>
              <!-- CSV report file for Mailchimp to ALV Sync-->
              <span v-if="csvReportMailchimpSyncFilepath !== null">
                  <BaseIcon 
                      @click.stop="downloadReportMailchimpSync(csvReportMailchimpSyncFilepath)" 
                      icon="cloud_download" 
                      :tooltipText="$t('lang_GENERAL_CAPTION_ICON_DOWNLOAD')" 
                      :alvqa="alvqa + '-icon-download-csv-report-bulk-edit-copy-shares'" 
                  />
              </span>

            </td>
            <td v-else></td>
            <!-- Only shown if its an GEMA Soundfile account, cwr types, mailchimp or helpjuice -->
            <td v-if="item.item.credentialsType === 'gema-soundfile' || 
                      item.item.credentialsType.includes('cwr') ||  
                      item.item.credentialsType == 'mailchimp' ||
                      item.item.credentialsType == 'helpjuice' ||
                      item.item.credentialsType == 'av-meldung-api'
                      " 
                class="text-center"
                :alvqa="alvqa + '-list-row-' + item.item.id + '-icon-connection'"
            >
              <BaseIcon 
                  @click="checkConnection(item.item)"
                  tooltipText="lang_ACCOUNT_CREDENTIALS_TOOLTIP_CHECK_CONNECTION" 
                  icon="link" 
                />
            </td>

            <td v-else></td>
            <!-- ******* -->
            <!-- v-if="showIcons" -->
            <td class="text-center">
              <BaseIcon 
                  @click="edit(item.item)" icon="edit" 
                  tooltipText="lang_GENERAL_CAPTION_ICON_EDIT"
                  :alvqa="alvqa + '-list-row-' + item.item.id + '-icon-edit'" 
              />
            </td>
            <td 
              class="text-center" 
              :alvqa="alvqa + '-list-row-' + item.item.id + '-icon-delete'"
            >
              <BaseIcon 
                  @click="deleteRow(item.item)" 
                  tooltipText="lang_GENERIC_CAPTION_DELETE" 
                  icon="delete" 
              />
            </td>
          </template>
        </BaseDataTableList>
      </template>
    </BaseListPage>
  </div>
  <!-- The part below will be shown if a user has a "coworker" Role and has no rights to access the credentials page -->
  <div v-else>
    <BaseListPage headline="lang_ACCOUNT_CREDENTIALS" :showSearchIcon="false" :showFiltersRow="false">
      <template v-slot:dataTable>
        <v-row>
          <v-col class="text-left" :alvqa="alvqa + '-list-title'" v-html="$t('lang_GENERIC_NO_PERMISSION_TO_ACCESS')">
          </v-col>
        </v-row>
      </template>
    </BaseListPage>
  </div>
</template>

<script>
import BaseListPage from '@/components/_base/BaseListPage'
import BaseDataTableList from "@/components/_base/BaseDataTableList"
import BaseButton from '@/components/_buttons/BaseButton'
import DeletionDialog from "@/components/_dialogs/DeletionDialog"
import CredentialsEditingDialog from './_dialogs/CredentialsEditingDialog'
import BaseIcon from "@/components/_buttons/BaseIcon"
import {
  DropdownAccountCredentialsType,
  DropdownAccountCredentialsRole
} from '@/assets/dropdowns/alvDropdowns.js'

import api from '@/api_alv'

export default {
  name: "CredentialsList",
  components: {
    BaseDataTableList,
    DeletionDialog,
    BaseIcon,
    BaseListPage,
    BaseButton,
    CredentialsEditingDialog,
  },
  data() {
    return {
      alvqa: "account-credentials",
      context: "Credentials",
      showMailchimpSyncIcon: true,
      showMailchimpSyncProgressBar: false,
      csvReportMailchimpSyncFilepath: null,
    };
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("lang_ACCOUNT_CREDENTIALS_TYPE"),
          align: "left",
          sortable: false,
          value: "credentialsType",
          class: "subtitle-1",
        },
        {
          text: this.$t("lang_ACCOUNT_CREDENTIALS_CAPTION_USERNAME_TOKEN"),
          align: "left",
          sortable: true,
          value: "usernameToken",
          class: "subtitle-1",
          width: "400px"

        },
        {
          text: this.$t("lang_ACCOUNT_CREDENTIALS_CAPTION_ROLE_CATEGORY"),
          align: "left",
          sortable: true,
          value: "type",
          class: "subtitle-1",

        },
        {
          text: "",
          align: "left",
          sortable: false,
          value: "test",
          class: "subtitle-1",
        },
        {
          text: "",
          sortable: false,
          value: "sync",
          width: "60px",
        },
        {
          text: "",
          sortable: false,
          value: 'test',
          width: "60px",
        },
        {
          text: "",
          sortable: false,
          value: "edit",
          width: "60px",
        },
        {
          text: "",
          sortable: false,
          value: "delete",
          width: "60px",
        }
      ]
    },
    getUserRole() {
      return this.$store.getters["getUserInformation"].role
    },
    getUserAccountId() {
      return this.$store.getters["getUserInformation"].id
    },
    additionalDeletionDialogText() {
      let text = ''
      let userName = this.$store.getters.getSelectedCredentialsUser
      if (userName !== null) {
        text += this.$t('lang_DELETION_DIALOG_ADDITIONAL_INFORMATION_TEXT') + ' ' + userName
      }

      return text

    }
  },
  methods: {
    addNewRow() {
      this.$store.commit('setShowEditingDialog', true)
      this.$store.commit("setCredentialsNewRow", true)
      this.$store.commit('setEditingDialogHeadline', this.$t('lang_GENERAL_CAPTION_NEW_ENTRY'))

      let defaultValues = JSON.parse(JSON.stringify(this.$store.getters.getDefaultCredentials))
      this.$store.commit('setCredentialsEditingDialogDetails', defaultValues)


    },
    deleteRow(item) {
      this.showIcons
      if (item.id === this.getUserAccountId && item.credentialsType === 'alv-login') {
        this.$store.commit('setSnackbar', {
          type: 'error',
          msg: this.$t("lang_ACCOUNT_CREDENTIALS_CAPTION_CANNOT_DELETE_OWN_ACCOUNT")
        })
        return
      } else {
        this.$store.commit("setSelectedCredentialsUser", item.username)// needed for show the user name in the deletion dialog
        this.$store.commit("setSelectedCredentials", item.idUnique);
        this.$store.commit("setShowDeletionDialog", true);
      }

    },
    maskPassword(password) {
      if (password.length > 0) return "\u2022".repeat(password.length);
      else return "";
    },
    maskApiKey(key){
      if(key.length > 6){
        var visibileChars = key.substring(0, 6);
        return visibileChars + "\u2022".repeat(key.length - 6)
      }else{
        return "\u2022".repeat(key.length)
      }
    },
    checkConnection(item) {
      this.$store.dispatch("checkCredentialsConnectionStatus", item);
    },
    getType(selection) {
      if (selection) {
        return DropdownAccountCredentialsType.find(obj => {
          return obj.value === selection
        }).text
      }
    },
    getRole(selection) {
      if (selection) {
        return DropdownAccountCredentialsRole.find(obj => {
          return obj.value === selection
        }).text
      } else {
        return ''
      }
    },
    edit(item) {
      this.$store.commit("setSelectedCredentials", item.id)
      this.$store.commit("setCredentialsNewRow", false)
      let deepCopy = JSON.parse(JSON.stringify(item))
      this.maskPassword(deepCopy.password)
      this.$store.commit("setCredentialsEditingDialogDetails", deepCopy)

      this.$store.commit('setEditingDialogHeadline', this.$t("lang_GENERAL_CAPTION_EDITING_ENTRY")) // set headline
      this.$store.commit("setShowEditingDialog", true)
    },
    async synchronizeContacts(item){
      this.showMailchimpSyncIcon = false;
      this.showMailchimpSyncProgressBar = true;
      const path = await this.$store.dispatch("checkSynchronizeContactsStatus", item);

      if(path){
          this.showMailchimpSyncProgressBar = false;
          this.csvReportMailchimpSyncFilepath = path
      }
    },
    downloadReportMailchimpSync(path) {
            api.getFileFromALV(path)
            this.csvReportMailchimpSyncFilepath = null,
            this.showMailchimpSyncIcon = true
            // this.$store.commit('setBulkEditCopySharesReportCsv', null)
        },
  }
};
</script>
